<template>
  <div class="line">
    <svg
      @click="moveToPreviousPage"
      style="cursor: pointer"
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="14"
      viewBox="0 0 9 14"
      fill="none"
    >
      <path
        d="M7.0299 1.34315L1.37305 7L7.0299 12.6569"
        stroke="#090741"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <span
      @click="moveToPage(page)"
      class="page"
      :class="selectedPage === page ? 'active' : ''"
      v-for="page of pages"
      :key="page"
    >
      {{ page }}
    </span>

    <svg
      @click="moveToNextPage"
      style="cursor: pointer"
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
    >
      <path
        d="M1.34315 1.34315L7 7L1.34315 12.6569"
        stroke="#090741"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
</template>

<script>
export default {
  props: ["total"],
  data() {
    return {
      selectedPage: 1,
    };
  },
  emits: ["pageChanged"],

  methods: {
    moveToNextPage() {
      if (this.selectedPage + 1 <= this.total) {
        this.selectedPage++;
      }
    },

    moveToPreviousPage() {
      if (this.selectedPage - 1 > 0) {
        this.selectedPage--;
      }
    },

    moveToPage(page) {
      this.selectedPage = page;
    },
  },

  watch: {
    selectedPage() {
      this.$emit("pageChanged", this.selectedPage);
    },
  },

  computed: {
    pages() {
      let pages = [];
      for (let i = 1; i <= this.total; i++) {
        pages.push(i);
      }
      return pages;
    },
  },
};
</script>

<style  scoped>
.line {
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: flex-end;
}
.page {
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  cursor: pointer;
}
.active {
  border-radius: 100px;
  background: #e2037e;
  color: #fff;
}
</style>